"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../CTAs/Button"));

var _IconHelpCircle = _interopRequireDefault(require("../Icons/IconHelpCircle"));

var _findParentWithCSS = _interopRequireDefault(require("../utils/findParentWithCSS"));

var _useKeyDown = _interopRequireDefault(require("../utils/useKeyDown"));

var _excluded = ["children", "classes", "dataTestId", "triggerAriaLabel"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Popover = function Popover(_ref) {
  var children = _ref.children,
      classes = _ref.classes,
      dataTestId = _ref.dataTestId,
      triggerAriaLabel = _ref.triggerAriaLabel,
      additionalProps = _objectWithoutProperties(_ref, _excluded);

  var popoverDialogRef = (0, _react.useRef)(null);
  var popoverTriggerRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      toggleShow = _useState2[0],
      setToggleShow = _useState2[1];

  var measurePopover = function measurePopover() {
    var _popoverTriggerRef$cu;

    var popoverTriggerClientRect = popoverTriggerRef === null || popoverTriggerRef === void 0 ? void 0 : (_popoverTriggerRef$cu = popoverTriggerRef.current) === null || _popoverTriggerRef$cu === void 0 ? void 0 : _popoverTriggerRef$cu.getBoundingClientRect();
    var popoverDialogMargin = Number(getComputedStyle(popoverDialogRef === null || popoverDialogRef === void 0 ? void 0 : popoverDialogRef.current).getPropertyValue('--popover-dialog-margin'));
    var popoverDialogMaxWidth = Number(getComputedStyle(popoverDialogRef === null || popoverDialogRef === void 0 ? void 0 : popoverDialogRef.current).getPropertyValue('--popover-dialog-max-width'));
    var closestOverflowHiddenParent = (0, _findParentWithCSS.default)(popoverTriggerRef === null || popoverTriggerRef === void 0 ? void 0 : popoverTriggerRef.current, 'overflow', 'hidden');
    var computedDialogWidth = document.documentElement.clientWidth - popoverDialogMargin * 2;
    var triggerDocumentRightSpacing = closestOverflowHiddenParent !== null && closestOverflowHiddenParent !== void 0 && closestOverflowHiddenParent.getBoundingClientRect().right ? (closestOverflowHiddenParent === null || closestOverflowHiddenParent === void 0 ? void 0 : closestOverflowHiddenParent.getBoundingClientRect().right) - popoverTriggerClientRect.right : document.documentElement.clientWidth - popoverTriggerClientRect.right;
    var triggerDocumentLeftSpacing = popoverTriggerClientRect.left - (closestOverflowHiddenParent === null || closestOverflowHiddenParent === void 0 ? void 0 : closestOverflowHiddenParent.getBoundingClientRect().x) || popoverTriggerClientRect.left;
    var dialogIsWiderThanDocumentClientWidth = popoverDialogMaxWidth > computedDialogWidth;
    var isRightClipped = triggerDocumentRightSpacing + popoverDialogMargin * 2 < popoverDialogMaxWidth / 2 || dialogIsWiderThanDocumentClientWidth;
    var isLeftClipped = triggerDocumentLeftSpacing + popoverDialogMargin * 2 < popoverDialogMaxWidth / 2 || dialogIsWiderThanDocumentClientWidth;
    var popoverDialogWidth = "".concat(popoverDialogMaxWidth, "px");
    var popoverX = "calc(-50% + ".concat(popoverTriggerClientRect.width / 2, "px)");

    if (isRightClipped && !isLeftClipped) {
      popoverX = "calc(-100% + ".concat(popoverTriggerClientRect.width + triggerDocumentRightSpacing - popoverDialogMargin, "px)");
    }

    if (isLeftClipped && !isRightClipped) {
      if (closestOverflowHiddenParent !== null && closestOverflowHiddenParent !== void 0 && closestOverflowHiddenParent.getBoundingClientRect().x) {
        popoverX = "".concat((closestOverflowHiddenParent === null || closestOverflowHiddenParent === void 0 ? void 0 : closestOverflowHiddenParent.getBoundingClientRect().x) - popoverTriggerClientRect.left + popoverDialogMargin, "px");
      } else {
        popoverX = "-".concat(popoverTriggerClientRect.left - popoverDialogMargin, "px");
      }
    }

    if (isLeftClipped && isRightClipped) {
      popoverDialogWidth = "".concat(computedDialogWidth, "px");
      popoverX = "-".concat(triggerDocumentLeftSpacing - popoverDialogMargin, "px");
    } // Future enhancement: Check if top of dialog is clipped ( Not needed for initially delivery, could be helpful on short mobile viewports)
    // if (isTopClipped) {
    // ...do something to the dialog layout
    // }
    // if (!isTopClipped) {
    // ...do nothing, or reset to default layout
    // }


    popoverDialogRef.current.style.setProperty('--popover-dialog-width', popoverDialogWidth);
    popoverDialogRef.current.style.setProperty('--popover-x', popoverX);
  };

  var handleResize = function handleResize() {
    if (toggleShow) measurePopover();
  };

  var handleExternalInteraction = function handleExternalInteraction(event) {
    if (toggleShow && popoverDialogRef.current && !popoverDialogRef.current.contains(event.target) && !popoverTriggerRef.current.contains(event.target)) {
      setToggleShow(false);
    }
  };

  (0, _useKeyDown.default)('Escape', function () {
    return setToggleShow(false);
  });
  (0, _react.useLayoutEffect)(function () {
    if (toggleShow) measurePopover();
    window.addEventListener('resize', handleResize);
    window.addEventListener('mousedown', handleExternalInteraction);
    window.addEventListener('focusin', handleExternalInteraction);
    return function () {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('mousedown', handleExternalInteraction);
      window.removeEventListener('focusin', handleExternalInteraction);
    };
  }, [toggleShow]);

  var PopoverIcon = function PopoverIcon() {
    return /*#__PURE__*/_react.default.createElement(_IconHelpCircle.default, {
      classes: "popover__trigger-icon"
    });
  };

  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames.default)('popover', classes, {
      'popover--is-open': toggleShow
    })
  }, additionalProps), /*#__PURE__*/_react.default.createElement(_Button.default, {
    ref: popoverTriggerRef,
    text: "",
    variant: "text-alternate",
    ariaLabel: triggerAriaLabel,
    ariaExpanded: toggleShow ? 'true' : 'false',
    classes: "popover__trigger",
    customIcon: PopoverIcon,
    clickMethod: function clickMethod() {
      return setToggleShow(!toggleShow);
    },
    size: "large",
    dataTestId: dataTestId
  }), toggleShow && /*#__PURE__*/_react.default.createElement("div", {
    className: "popover__elements"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "popover__dialog",
    ref: popoverDialogRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "popover__dialog-content",
    "aria-live": "polite"
  }, children)), /*#__PURE__*/_react.default.createElement("svg", {
    "aria-hidden": true,
    className: "popover__dialog-pointer",
    viewBox: "0 0 48 16",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0,0 L48,0 L47.5733294,4.73233022 C44.5842978,4.74865449 41.6596048,5.60194593 39.1307344,7.1954927 L26.132494,15.3862265 C24.8294003,16.2073602 23.1705997,16.2073602 21.867506,15.3862265 L8.86926557,7.1954927 C6.3403952,5.60194593 3.41570223,4.74865449 0.426670593,4.73233022 L0,0 Z"
  }))));
};

Popover.propTypes = {
  /**
   Required. The content that appears when the popover is opened.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired,

  /**
   Optional. String to add custom class(es) to the component. Defaults to `null`.
   */
  classes: _propTypes.default.string,

  /**
   Optional. A unique identifier passed to the element for use in testing scenarios. Defaults to `null`.
   */
  dataTestId: _propTypes.default.string,

  /**
   Optional. Sets the aria-label attribute used by screen readers for the popover trigger button.  Defaults to "Toggle popover".
   */
  triggerAriaLabel: _propTypes.default.string
};
Popover.defaultProps = {
  classes: null,
  dataTestId: null,
  triggerAriaLabel: 'Toggle popover'
};
var _default = Popover;
exports.default = _default;